import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Weather from "./Weather";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Weather.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <div className="container">
      <Weather defaultCity="New York" />
      <br />
      <p className="footer">
        <a
          href="https://github.com/evaw277/react-weather"
          target="_blank"
          rel="noreferrer"
        >
          open-source code
        </a>
        , by Eva Weisneck
      </p>
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
